import { createSelector } from "@reduxjs/toolkit";
import { initialState } from "store/auth/slice";

const selectAuthDomain = (state) => state.auth || initialState;

export const selectUser = createSelector(
  [selectAuthDomain],
  (authState) => authState.authUser
);
